import { Dokument } from '@core/models/user';

export class AgreeJurPersonObj {
  JurDaten: {
    Personenart: string;
    Kundenart: string;
    Anrede: string;
    Briefanrede: string;
    // NamePraegekarte: string;
    // NamePraegekarte2: string;
    Firmenname: string;
    Kurzname: string;
    AnzMitarbeiter?: number;
    StandAnzMitarbeiter?: string;
    Gruendungsland: string;
    Gruendungsort: string;
    Gruendungsdatum?: string;
    RechtsformAuspraegung: string;
    NiederlassungLand: string;
    GbrArt: string;
  };
  Vertragsdaten: {
    Stammvertrag: string;
    Stammvertragsdatum: string;
    Geschaeftsstelle: number;
    NrBerater: number;
    Kundensegment: number;
  };
  Wirtschaftsdaten: {
    Wirtschaftszweig: string;
    WirtschaftszweigNumerisch: number;
    WZAnteil: number;
    SteuerID: string;
    GWGRisikoklasse: string;
  };
  Registerdaten: {
    Registerart: string;
    Registergericht: string;
    Registernummer: string;
    EintragDatum: string;
    RegAuszugDatum: string;
    RegGeprueftVon: string;
    RegGeprueftAm: string;
  };
  Adresse: {
    PLZ: string;
    Ort: string;
    Strasse: string;
    Land: string;
  };
  Kontaktdaten: {
    Kontakt: [
      {
        LaufendeNummer: number;
        Kontaktart: string;
        Kontaktmedium: string;
        Wert: string;
      },
      {
        LaufendeNummer: number;
        Kontaktart: string;
        Kontaktmedium: string;
        Wert: string;
      },
    ];
  };
  Dokumente: {
    Handelsregisterauszug: Dokument;
    Transparenzregister: Dokument;
    Gesellschafterliste: Dokument;
    Gesellschaftsvertrag: Dokument;
    AusweiskopieVertretungsberechtigten: Dokument;
    Gewerberegister: Dokument;
    Gesellschafterregister: Dokument;
    AusweiskopieWB: Dokument;
    Nachweis_bei_WB: Dokument;
  };
}

export class AgreeNatPersonObj {
  NatDaten: {
    Personenart: string;
    Kundenart: string;
    Anrede: string;
    Titel?: string;
    Vorname?: string;
    Nachname?: string;
    Briefanrede: string;
    Geburtsname?: string;
    Geburtsdatum?: string;
    Geburtsort?: string;
    Geburtsland: string;
    RechtsformAuspraegung: string;
  };
  Vertragsdaten: {
    Stammvertrag: string;
    NrBerater: number;
    Kundensegment: number;
    Geschaeftsstelle?;
  };
  Wirtschaftsdaten: {
    Wirtschaftszweig?: string;
    Berufe?: {
      Beruf: [
        {
          Berufsbezeichnung: string;
          Berufsgruppe: string;
          selbststaendig: boolean;
        },
      ];
    };
    SteuerID?: string;
    GWGRisikoklasse: string;
  };

  Legitimationsdaten: {
    Ausweisart: string;
    Ausweisnummer: string;
    AusstellerLand: string;
    AusstellerBehoerde: string;
    AusgestelltAm: string;
    GueltigBis: string;
    GeprueftAm: string;
    GeprueftVonID: string;
    AusfOrganisation: string;
    ausweiskopieVorh?: boolean;
    Staatsangehoerigkeit: string;
    sonstBez?: string;
  };
  Adresse: {
    PLZ: string;
    Ort: string;
    Strasse: string;
    Land: string;
  };

  Kontaktdaten: {
    Kontakt: [
      {
        LaufendeNummer: number;
        Kontaktart: string;
        Kontaktmedium: string;
        Wert: string;
      },
      {
        LaufendeNummer: number;
        Kontaktart: string;
        Kontaktmedium: string;
        Wert: string;
      },
    ];
  };
}

export class RoleCall {
  NehmerID: number;
  GeberID: number;
  RollenID?: string;
  Bemerkung?: string;
  Rollenbezeichnung: string;
  RollenCode: number;
}
